import { createContext, useContext } from "react";

/**
 * Generic interface of a function handling errors with a title.
 * Error-handling includes logging and displaying the error to the user, unless it can be resolved automatically.
 */

export const ErrorHandlingContext = createContext(null);

/**
 * Hook to get access to error-handling functions.
 * Must be used within an ErrorBoundary.
 */
export function useErrorContext() {
  const context = useContext(ErrorHandlingContext);
  if (!context) {
    throw new Error("useErrorContext() has to be used within an ErrorHandlingContext.");
  }
  return context;
}